import HeaderCell from "components/table/HeaderCell";
import { ReactComponent as Edit2 } from "../../assets/svgs/edit.svg";
import { ReactComponent as ViewIcon } from "../../assets/svgs/eye.svg";
import { Box, Tag, Text } from "@chakra-ui/react";
import moment from "moment";

const getStatusBackgroundColor = (status) => {
  switch (status?.toLowerCase()) {
    case "multiple":
      return "#456EFF1A";
    case "live":
    case "shopify":
      return "#00FF3810";
    case "sold":
      return "#FF000016";
    case "photo":
      return "#FFC70016";
    case "hidden":
      return "#74787B10";
    case "rejected":
      return "#B92C5316";
    case "dry cleaning":
      return "#5450A310";
    default:
      return "#FFC70010";
  }
};

const getStatusTextColor = (status) => {
  switch (status?.toLowerCase()) {
    case "multiple":
      return "#456EFF";
    case "live":
    case "shopify":
      return "#00FF38";
    case "sold":
      return "#FF0000";
    case "photo":
      return "#FFC700";
    case "hidden":
      return "#74787B";
    case "rejected":
      return "#B92C53";
    case "dry cleaning":
      return "#5450A3";
    default:
      return "#FFC700";
  }
};

const getApprovalStatus = (instance) => {
  if (
    instance?.seller_approved === true &&
    instance?.seller_rejected === false
  ) {
    return "Approved";
  } else if (
    instance?.seller_approved === false &&
    (instance?.seller_rejected === true || instance?.seller_rejected === false)
  ) {
    return "Pending";
  } else {
    return "-";
  }
};

const columns = ({
  onEditOpen,
  onViewOpen,
  setSelectedProduct,
  statusFilter,
  // onSelectRow = () => {},
}) => [
  // {
  //   id: 1,
  //   cell: (row) =>
  //     statusFilter === "preview" ? (
  //       <input
  //         type="checkbox"
  //         onChange={(e) => {
  //           onSelectRow(e.target.checked, {
  //             productId: row?._id,
  //             variantId: row?.variants?._id,
  //             instanceId: row?.variants?.instances?._id,
  //           });
  //         }}
  //       />
  //     ) : null,
  //   ignoreRowClick: true,
  //   button: true,
  //   width: statusFilter === "preview" ? "50px" : "10px",
  // },
  {
    id: 2,
    name: <HeaderCell label={"SKU"} />,
    selector: (row) => row?.variants?.sku,
    width: "100px",
  },
  {
    id: 3,
    name: <HeaderCell label={"PRODUCT TITLE"} />,
    selector: (row) => row.product_title,
    width: statusFilter === "Pending Approval" ? "235px" : "260px",
  },
  {
    id: 4,
    name: <HeaderCell label={"LOCATION"} />,
    selector: (row) => row?.variants?.instances?.location?.name,
    width: "175px",
  },
  {
    id: 11,
    name: <HeaderCell label={"AGE/SIZE"} />,
    selector: (row) => row?.variants?.age_detail?.age_value,
    width: "175px",
  },
  {
    id: 5,
    width: "200px",
    name: <HeaderCell label={"STATUS"} />,
    selector: (row) => row?.variants?.instances?.status,
    cell: (row) => {
      const status = row?.variants?.instances?.status;
      const displayStatus =
        status === "shopify"
          ? "Live"
          : status === "dry-cleaning"
          ? "Dry Cleaning"
          : status
          ? status.charAt(0).toUpperCase() + status.slice(1)
          : "";

      return (
        <Tag
          bg={getStatusBackgroundColor(status)}
          borderRadius="full"
          px="4"
          py="2"
          w={"auto"}
          justifyContent={"center"}
          alignItems={"center"}
          color={getStatusTextColor(status)}
          fontFamily={"PlusJakartaSansRegular"}
          fontSize={"16px"}
        >
          <Box
            bg={getStatusTextColor(status)}
            width={"8px"}
            height={"8px"}
            borderRadius={50}
            marginRight={"10px"}
          />
          {displayStatus}
        </Tag>
      );
    },
  },
  // {
  //   id: 6,
  //   width: "200px",
  //   name: <HeaderCell label={"APPROVAL STATUS"} />,
  //   selector: (row) => row?.variants?.instances?.status,
  //   cell: (row) => {
  //     return row?.variants?.instances?.status !== "preview" ? (
  //       <Box flex={1}>
  //         <Text textAlign={"center"}> - </Text>
  //       </Box>
  //     ) : (
  //       <Tag
  //         bg={getStatusColor(getApprovalStatus(row?.variants?.instances))}
  //         borderRadius="full"
  //         px="4"
  //         py="2"
  //         w={"auto"}
  //         justifyContent={"center"}
  //         alignItems={"center"}
  //         color={getStatusTextColor(
  //           getApprovalStatus(row?.variants?.instances)
  //         )}
  //         fontFamily={"PlusJakartaSansRegular"}
  //         fontSize={"16px"}
  //       >
  //         <Box
  //           bg={getStatusTextColor(getApprovalStatus(row?.variants?.instances))}
  //           width={"8px"}
  //           height={"8px"}
  //           borderRadius={50}
  //           marginRight={"10px"}
  //         />
  //         {/* {row?.variants?.instances?.seller_approved === true &&
  //         row?.variants?.instances?.seller_rejected === false
  //           ? "Approved"
  //           : row?.variants?.instances?.seller_approved === false &&
  //             row?.variants?.instances?.seller_rejected === true
  //           ? "Pending"
  //           : row?.variants?.instances?.seller_approved === false &&
  //             row?.variants?.instances?.seller_rejected === false
  //           ? "Pending"
  //           : "-"} */}
  //         {getApprovalStatus(row?.variants?.instances)}
  //       </Tag>
  //     );
  //   },
  // },
  {
    id: 6,
    name: <HeaderCell label={"ORIGINAL RRP"} />,
    selector: (row) => {
      const rrp = row?.variants?.instances?.original_rrp;
      if (!rrp || rrp === "-") return "-";
      return `£${Number(rrp).toFixed(2)}`;
    },
    width: "175px",
  },
  // {
  //   id: 11,
  //   name: <HeaderCell label={"ORIGINAL RRP"} />,
  //   selector: (row) => row?.variants?.instances?.original_rrp,
  //   width: "175px",
  // },
  {
    id: 7,
    name: <HeaderCell label={"KWC PRICE"} />,
    selector: (row) => {
      const status = row?.variants?.instances?.status?.toLowerCase();
      if (status === "rejected") {
        return "-";
      }
      const price = row?.variants?.instances?.kwc_price;
      if (!price || price === "-") return "-";
      return `£${Number(price).toFixed(2)}`;
    },
    width: "175px",
  },
  {
    id: 8,
    name: <HeaderCell label={"SOLD DATE"} />,
    selector: (row) =>
      row?.variants?.instances?.status === "sold"
        ? moment(row?.variants?.instances?.sold_date).format("DD/M/YYYY")
        : "-",
    width: "175px",
  },

  {
    id: 9,
    name: <HeaderCell label={"PAYMENT DATE"} />,
    selector: (row) => {
      const instance = row?.variants?.instances;

      if (
        instance?.status === "sold" &&
        moment(instance?.sold_date).isValid()
      ) {
        return moment(instance.sold_date).add(30, "days").format("DD/M/YYYY");
      }

      return "-";
    },

    width: "175px",
  },
  {
    id: 10,
    name: <HeaderCell label={"ACTION"} />,
    cell: (row) => (
      // row.status === "Pending Approval" ? (
      //   <Edit2
      //     width={20}
      //     height={20}
      //     cursor={"pointer"}
      //     onClick={() => onEditOpen(row)}
      //   />
      // ) : (
      <ViewIcon
        width={20}
        height={20}
        cursor={"pointer"}
        onClick={() => {
          setSelectedProduct(row);
          onViewOpen(row);
        }}
      />
    ),
    // ),
    ignoreRowClick: true,
    button: true,
    width: "125px",
  },
];

const data = [
  {
    bag_id: "123",
    id: 1,
    product_name: "dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Pending Approval",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 2,
    product_name: "another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Live",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 3,
    product_name: "yet another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Sold",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 4,
    product_name: "so on dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Rejected",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 5,
    product_name: "dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Pending Approval",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 6,
    product_name: "another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Live",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 7,
    product_name: "yet another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Sold",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 8,
    product_name: "so on dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Rejected",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 9,
    product_name: "dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Pending Approval",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 10,
    product_name: "another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Live",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 11,
    product_name: "yet another dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Sold",
    website_link: "https://www.google.com",
  },
  {
    bag_id: "123",
    id: 12,
    product_name: "so on dummy product name",
    brand_name: "dummy brand name",
    location: "UK",
    status: "Rejected",
    website_link: "https://www.google.com",
  },
];

export { data, columns };
